export default __webpack_public_path__ + "static/media/pt-20.72def061.svg";